
import SearchZoomOut1 from "../../../assets/duotone/SearchZoomOut1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SearchZoomOut1Icon({ className, dataTestid = "SearchZoomOut1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SearchZoomOut1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
